export default __webpack_public_path__ + "static/media/Cloudxier graphics-each-expertise-03.dbb570af.png";